// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2MQ02","rootSuccess":"CompleteLink_rootSuccess__3e3oZ","rootFailure":"CompleteLink_rootFailure__zQiC1","isDisabled":"CompleteLink_isDisabled__1D3Kc"};